import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test3.css";
import answer from "../QA/Test3_q_a/answer"; // 解答をインポート
import kensa3_example from "../QA/Test3_q_a/kensa3_example.jpg";
import kensa3 from "../QA/Test3_q_a/kensa3.jpg";

const Test3 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [isTest3Started, setIsTest3Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score3 = React.useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 90;
  const totalQuestions = 36;

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;
    for (let i = 0; i < totalQuestions; i++) {
      const userAnswer = inputValues[i + 1];
      const correctAnswer = answer[i + 1];
      if (userAnswer === correctAnswer) {
        calculatedScore += 1;
      }
    }

    score3.current = calculatedScore;
    localStorage.setItem("score3", calculatedScore);

    const normalizedScore = scoreTable.scoreTable6[String(calculatedScore)] ?? 0;
    const currentPScore = parseInt(localStorage.getItem("P_score"), 10) || 0;
    const updatedPScore = currentPScore + normalizedScore;
    localStorage.setItem("P_score", updatedPScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ←ここで次の検査へ進む
  }, [inputValues, scoreTable, onNext]);

  const handleStartTest = () => {
    setIsTest3Started(true);
    localStorage.setItem("test3Status", "started");
  };

  const handleInputChange = (index, value) => {
    const hiraganaOnly = value.replace(/[^ぁ-ん]/g, "");
    setInputValues((prev) => ({ ...prev, [index]: hiraganaOnly }));
    if (hiraganaOnly !== "" && index === currentQuestionIndex + 1) {
      setCurrentQuestionIndex(index);
    }
  };

  if (!isTest3Started) {
    const exampleAnswers = ["え", "い", "あ", "お", "う", "か", "く", "き"];
  
    return (
      <div className="test3-container">
        <h1>検査1 - やり方の説明</h1>
        <p>同じ図形を左から探して記号を入力します。</p>
  
        <h2>例題</h2>
        <div className="example-container">
          <img src={kensa3_example} alt="例題3" className="test3-image-example" />
        </div>
  
        <div className="example-inputs">
          {exampleAnswers.map((char, index) => (
            <div key={index} className="example-answer-block">
              <span className="example-label">回答{index + 1}</span>
              <input
                type="text"
                value={char}
                className="test3-input example-answer"
                readOnly
              />
            </div>
          ))}
        </div>
  
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  const renderedQuestions = [
    <div key="main-image" className="test3-main-image">
      <p><strong>※解答欄は画像の下にあります。</strong></p>
      <img src={kensa3} alt="検査画像" className="test3-image" />
    </div>,
    ...Array.from({ length: totalQuestions })
      .slice(0, currentQuestionIndex + 1)
      .reduce((groups, _, index) => {
        const groupIndex = Math.floor(index / 5);
        if (!groups[groupIndex]) groups[groupIndex] = [];
        groups[groupIndex].push(
          <div key={index} className="test3-question">
            <div className="test3-answer-sheet">
              <p>問題 {index + 1}</p>
              <input
                type="text"
                value={inputValues[index + 1] || ""}
                onChange={(e) => handleInputChange(index + 1, e.target.value)}
                maxLength={1}
                pattern="[ぁ-ん]"
                className="test3-input"
                placeholder="ひらがな"
              />
            </div>
          </div>
        );
        return groups;
      }, [])
      .map((group, idx) => (
        <div key={`group-${idx}`} className="test3-group">
          {group}
        </div>
      )),
  ];

  return (
    <ZoomControls>
      <TestContainer
        title="検査1"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test3);